import type { ResolveConversationMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { ResolveConversationDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Flag-gated wrapper (RSP-6496). Both paths return `{ Id }`.
 */
export const useResolveConversation = createMutationHook({
  name: 'resolveConversation',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.conversation.resolve.mutationOptions({ onSuccess }),
  mapInput: (input: { Id: string }) => input,
  invalidate: (trpc) => [
    trpc.frontend.comment.commentsByConversationId.queryKey(),
  ],
  mapResponse: (result: { Id: string }): { Id: string } => ({
    Id: result.Id,
  }),
  graphqlDocument: ResolveConversationDocument,
  graphqlVariables: (input: { Id: string }) => ({ Id: input.Id }),
  mapGraphqlResponse: (data: ResolveConversationMutation): { Id: string } => {
    if (!data.update_conversation_by_pk) {
      throw new Error('Failed to resolve conversation');
    }

    return { Id: data.update_conversation_by_pk.Id };
  },
});
